import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NGXLogger} from 'ngx-logger';
import {GroupService} from '../../../../../_services/group.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'acabim-admin-groups-site-add',
    templateUrl: './add-site-group.component.html'
})
export class GroupSiteAddComponent implements OnInit, OnDestroy {

    @Output() completed = new EventEmitter<string>();
    loading = false;
    siteGroupForm: FormGroup | undefined;
    private _currentProcess: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private groupService: GroupService
    ) {}

    ngOnInit(): void {
        this.siteGroupForm = new  FormGroup({
            siteGroupName: new FormControl()
        });
    }

    onSiteGroupAddSubmit(): void {
        console.log('Running Add onSubmit for Site Group');
        this.upsertSiteGroup();
    }

    private upsertSiteGroup(): void {
        this.loading = true;
        this.logger.debug('[GroupSiteAddComponent] Adding new site-and-project group');
        this._currentProcess = this.groupService.upsertSiteGroup(
            this.siteGroupForm?.value.siteGroupName
        ).subscribe(newSiteGroup => {
            this.logger.debug('[GroupSiteAddComponent] Site group added successfully: ', newSiteGroup.id);
            this.clearForm();
            this.completed.emit('added');
            this.loading = false;
            console.log('Upsert: added');
        }, (error: any) => {
            this.logger.debug('[GroupSiteAddComponent] Site group failed to add');
            this.logger.error(error);
            this.loading = false;
        });
    }

    onCancel(): void {
        this.logger.debug('[GroupSiteAddComponent] Add Site Group Modal Cancelled');
        console.log('Upsert: cancelling');
        this.completed.emit('cancelled');
    }

    clearForm(): void {
        this.siteGroupForm?.patchValue({
            siteGroupName: null
        });
    }

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
    }
}
